






import {Component, Vue} from 'vue-property-decorator';

import {Enum}      from '@/app/shared/enum/enum';
import {broadcast} from '@/core/service/broadcast.service';

@Component
export default class NSpinner extends Vue {
  anim: HTMLElement | null = null;
  size: number = 80;
  active = {visible: false, cnt: 0};

  mounted() {
    const progressLayer: HTMLElement = document.getElementById('progressLayer') as HTMLElement;

    // @ts-ignore
    this.anim = bodymovin.loadAnimation({
      container: progressLayer.children[0],
      renderer : 'svg',
      loop     : true,
      autoplay : false,
      path     : '/resources/js/spinner.min.json'
    });

    broadcast.$on(Enum.CORE.SPINNER.DEFAULT, this.onDefaultSpinner);
    broadcast.$on(Enum.CORE.SPINNER.SPINNER_ERROR, this.onErrorSpinner);
  }

  beforeDestroy() {
    broadcast.$off(Enum.CORE.SPINNER.DEFAULT, this.onDefaultSpinner);
    broadcast.$off(Enum.CORE.SPINNER.SPINNER_ERROR, this.onErrorSpinner);
  }

  onDefaultSpinner(useYn: boolean) {
    this.activeSpinner(useYn, this.active);
  }

  activeSpinner(useYn: boolean, active: { visible: boolean; cnt: number; }) {
    if (useYn) {
      if (active.cnt === 0) {
        active.visible = true;
        // @ts-ignore
        this.anim.play();
      }

      active.cnt++;

    } else {
      if (active.cnt !== 0) {

        active.cnt--;

        if (active.cnt === 0) {
          active.visible = false;
          // @ts-ignore
          this.anim.stop();
        }
      }
    }
  }

  onErrorSpinner() {
    this.active.cnt = 0;
    this.active.visible = false;
    // @ts-ignore
    this.anim.stop();
  }
}
